import React, { useMemo } from "react";
import DataGrid, { Column, SearchPanel, GroupPanel, Paging } from "devextreme-react/data-grid";
import './Glossary.css';
import PageShell from '../components/layout/PageShell';

interface GlossaryEntry {
  letter: string;
  term: string;
  description: string;
}

const glossary: GlossaryEntry[] = [
  { letter: "C", term: "Calmar ratio", description: "Measures return relative to drawdown." },
  { letter: "C", term: "Christoffersen Independence test", description: "Checks whether VaR breaches (exceptions) occur independently over time — i.e., they should not cluster." },
  { letter: "C", term: "Component VaR", description: "Decomposes total portfolio VaR into risk contributions by group/trader." },
  { letter: "C", term: "Component ETL", description: "Decomposes total portfolio ETL into risk contributions by group/trader." },

  { letter: "E", term: "Expected Tail Loss", description: "Also called Expected Shortfall or Conditional VaR - measures the average loss beyond the VaR threshold." },

  { letter: "G", term: "Gain to pain ratio", description: "Measures how much profit is generated for every unit of loss." },

  { letter: "J", term: "Joint Conditional Coverage Test", description: "Verifies that a VaR model produces the correct number of exceptions and that exceptions are independent (not clustered). A good VaR model should satisfy both simultaneously." },

  { letter: "K", term: "Kupiec POF test (Proportion of Failures Test)", description: "Checks whether the observed frequency of VaR exceptions matches the expected frequency implied by the VaR confidence level." },

  { letter: "I", term: "Incremental VaR", description: "VaR change when removing a group/trader/trade." },

  { letter: "S", term: "Sharpe ratio", description: "Measures risk adjusted return - how much excess return is earned per unit of risk taken." },
  { letter: "S", term: "Sortino ratio", description: "A refinement of the Sharpe ratio that penalises only downside risk, not upside volatility." },
  { letter: "S", term: "Stressed ETL", description: "Measures the average loss in the tail beyond VaR, under extreme but plausible market conditions, calibrated to a historical stress period." },
  { letter: "S", term: "Stressed VaR", description: "Measures losses under extreme but plausible market conditions, calibrated to a historical stress period." },
];


export default function GlossaryPage(): React.ReactElement {
  const data = useMemo(() => glossary, []);


  return (
      <PageShell>
      <div className="var-container">

          <DataGrid
            dataSource={data}
            showBorders={false}
            rowAlternationEnabled
            columnAutoWidth
            wordWrapEnabled
            height="calc(100vh - 210px)"
            className="glossary-grid"
          >
            <SearchPanel visible highlightCaseSensitive={false} />
            <GroupPanel visible />
            <Paging enabled={false} />

            <Column dataField="letter" caption="Letter" width={90} groupIndex={0} />
            <Column dataField="term" caption="Term" cssClass="glossary-term" />
            <Column dataField="description" caption="Definition" cssClass="glossary-desc" />
          </DataGrid>
       </div>
      </PageShell>

  );
}
